module.exports = __webpack_public_path__ + "static/img/m5.669bd59.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/iot/m5.png
// module id = 1oY/
// module chunks = 0